import PropTypes from "prop-types";
import logoDark from "assets/images/logo-dark.png";
import logoLight from "assets/images/logo-white.png";

const Logo = ({ dark = false, width = 100 }) => {
  const source = dark ? logoDark : logoLight;

  return <img src={source} alt="Geograph G" width={width} />;
};

Logo.propTypes = {
  dark: PropTypes.bool,
  width: PropTypes.number,
};

export default Logo;
